// import { Loading } from 'quasar'
import router from '../router'
import axios from 'axios'

const state = {
  loggedIn: false,
  registered: false,
  mobileVerified: false,
  activeRoute: 'dashboard',
  apiToken: null,
  line: {
    displayName: null,
    pictureUrl: null,
    statusMessage: null,
    userId: null
  },
  userProfile: {
    citizenId: null,
    mobile: null
  }
}

const mutations = {
  setLine (state, data) {
    data.statusMessage = '-'
    Object.assign(state.line, data)
    state.loggedIn = true
  },
  setProfile (state, data) {
    Object.assign(state.userProfile, data)
    state.registered = true
  },
  setRegister (state, data) {
    state.apiToken = data
    state.registered = true
    localStorage.setItem('api_token', data)
  },
  setForbidden (state) {
    state.apiToken = null
    state.registered = false
    localStorage.removeItem('api_token')
  },
  setMobileVerified (state) {
    state.mobileVerified = true
  },
  setActiveRoute (state, data) {
    state.activeRoute = data
  }
}

const actions = {
  setLine ({ commit }, data) {
    commit('setLine', data)
  },
  registerUser ({ commit }, payload) {
    // console.log(payload)
    // Loading.show()
    commit('setProfile', payload)
  },
  setProfile ({ commit }, data) {
    commit('setProfile', data)
  },
  setRegister ({ commit }, data) {
    commit('setRegister', data)
    // localStorage.setItem('api_token', data)
  },
  setForbidden ({ commit }) {
    commit('setForbidden')
  },
  setMobileVerified ({ commit }) {
    commit('setMobileVerified')
  },
  setActiveRoute ({ commit }, data) {
    commit('setActiveRoute', data)
  },
  handleLogin ({ commit, dispatch }) {
    // console.log('api_token: ', state.apiToken)
    // console.log('registered: ', state.registered)
    // console.log('mobileVerified: ', state.mobileVerified)
    // console.log('activeRoute: ', state.activeRoute)

    if (localStorage.getItem('api_token') !== null) {
      // console.log('set api_token: ', localStorage.getItem('api_token'))
      // commit('setRegister', localStorage.getItem('api_token'))
      commit('setMobileVerified')
      commit('setRegister', localStorage.getItem('api_token'))
      if (state.activeRoute !== null) {
        router.replace(state.activeRoute, () => { })
      } else {
        router.replace('dashboard', () => { })
      }
    } else if (state.registered !== true) {
      // console.log('call this.auththen()')
      dispatch('authen')
    } else if (state.mobileVerified !== true) {
      if (router.currentRoute.path !== '/otp') {
        router.replace('otp', () => { })
      }
    }

    // if (state.registered !== true && state.mobileVerified === true) {
    //   router.replace('/register', () => { })
    // } else if (state.loggedIn === true && state.registered === true && state.mobileVerified === false) {
    //   router.replace('/otp', () => { })
    // } else {
    //   if (state.activeRoute !== null) {
    //     router.replace(state.activeRoute, () => { })
    //   }
    // }
  },
  authen ({ commit }) {
    const lineId = state.line.userId
    // console.log('lineId: ', lineId)
    axios.post(`${process.env.VUE_APP_API}api/auth`, { line_id: lineId })
      .then((res) => {
        // console.log(res.data)
        if (res.data != null) {
          if (res.data.api_token) {
            commit('setRegister', res.data.api_token)
            commit('setMobileVerified')
            // this.setRegister(res.data.api_token)
            if (state.activeRoute !== null) {
              router.replace(state.activeRoute, () => { })
            } else {
              router.replace('dashboard', () => { })
            }
          } else {
            if (router.currentRoute.path !== '/otp') {
              router.replace('otp', () => { })
            }
          }
        }
      })
      .catch(e => {
        // if (e.response.status === 401) {
        //   console.log(e.response.status)
        // this.$router.push('/register', () => { })
        commit('setForbidden')
        router.replace('register', () => { })
        // }
      })
  }
}

const getters = {
  getLine: state => {
    // console.log(state.line)
    return state.line
  },
  getProfile: state => {
    return state.userProfile
  },
  getActiveRoute: state => {
    return state.activeRoute
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
